module.exports = __webpack_public_path__ + "img/gymkhana.8ccdde5d.jpg";